import { render, staticRenderFns } from "./recharge-details.vue?vue&type=template&id=2ddf49a7&scoped=true&"
import script from "./recharge-details.vue?vue&type=script&lang=js&"
export * from "./recharge-details.vue?vue&type=script&lang=js&"
import style0 from "./recharge-details.vue?vue&type=style&index=0&id=2ddf49a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddf49a7",
  null
  
)

export default component.exports